// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1XaGM","item":"PaymentsMobile_item__2qSzI","label":"PaymentsMobile_label__3LCUy","amount":"PaymentsMobile_amount__1NxhT"};